(function () {
  if (window.__finderTracking) return;
  window.__finderTracking = true;

  var used = false;
  var lastQuery = '';
  var timer = null;
  var pending = null;

  function lang() { return (document.documentElement.lang || '').slice(0, 2); }

  function activeTab(r) {
    var b = r.querySelector('[data-tab][aria-pressed="true"]');
    return b ? b.getAttribute('data-tab') : '';
  }

  // Sends one event to every place that can receive it: dataLayer (GTM), gtag (GA4) and Shopify customer events.
  function emit(name, params) {
    var ev = 'finder_' + name;
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: ev };
      for (var k in params) d[k] = params[k];
      window.dataLayer.push(d);
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, params); } catch (e) {}
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(ev, params);
    } catch (e) {}
  }

  function track(r, name, extra) {
    extra = extra || {};
    var params = { tab: activeTab(r), lang: lang(), path: location.pathname };
    for (var k in extra) params[k] = extra[k];
    // GA4 already has event_category and event_label as custom dimensions, so the search word,
    // product or pick shows up in reports under event_label without registering anything new.
    params.event_category = 'finder';
    params.event_label = String(extra.query || extra.product || extra.value || extra.tab || extra.source || '').slice(0, 80);
    if (!used && name !== 'view') {
      used = true;
      emit('first_use', { tab: params.tab, lang: params.lang, path: params.path, action: name, event_category: 'finder', event_label: name });
    }
    emit(name, params);
  }

  // Writes the source of the last result click onto the cart, so the order carries a "finder" attribute.
  function tagCart(r, source) {
    try {
      var base = r.getAttribute('data-root') || '/';
      if (base.slice(-1) !== '/') base += '/';
      fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { finder: source } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  // Searches: wait for a pause in typing, then read what the finder is showing.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-label-finder] [data-search]')) return;
    clearTimeout(timer);
    var run = function () {
      pending = null;
      var r = t.closest('[data-label-finder]');
      if (!r) return;
      var q = (t.value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (q.length < 2) { lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      var none = !!r.querySelector('[data-results] .label-finder__none');
      var n = none ? 0 : r.querySelectorAll('[data-results] .label-finder__card').length;
      track(r, 'search', { query: q.slice(0, 80), results: n });
      if (none) track(r, 'no_results', { query: q.slice(0, 80) });
    };
    pending = run;
    timer = setTimeout(run, 900);
  });

  // Clicks are read in the capture phase, before the finder redraws its chips and results.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var r = t.closest('[data-label-finder]');
    if (!r) return;

    var tab = t.closest('[data-tab]');
    if (tab) { track(r, 'tab', { tab: tab.getAttribute('data-tab') }); return; }

    var chip = t.closest('.label-finder__chip');
    if (chip) {
      var box = chip.closest('[data-chips]');
      track(r, 'chip', { step: box ? box.getAttribute('data-chips') : '', value: chip.textContent.trim().slice(0, 40) });
      return;
    }

    var card = t.closest('.label-finder__card');
    if (card) {
      if (pending) { clearTimeout(timer); pending(); }
      var input = r.querySelector('[data-search]');
      var source = (input && input.value.trim().length >= 2) ? 'search' : activeTab(r);
      var nameEl = card.querySelector('.label-finder__name');
      var m = /\/products\/([^\/?#]+)/.exec(card.getAttribute('href') || '');
      var holder = card.parentNode;
      var pos = holder ? Array.prototype.indexOf.call(holder.children, card) + 1 : 0;
      track(r, 'result_click', {
        source: source,
        product: m ? m[1] : '',
        name: nameEl ? nameEl.textContent.trim().slice(0, 80) : '',
        position: pos,
        in_extras: !!(holder && holder.hasAttribute('data-extras-results'))
      });
      tagCart(r, source);
    }
  }, true);

  // Counts how many visitors actually see the finder: the denominator for everything else.
  function watch() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); track(en.target, 'view'); }
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('[data-label-finder]').forEach(function (n) { io.observe(n); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
